import { RequestService } from '../../../common/services/RequestService';
import { GET_REGIONS } from '../constants';

export const getRegions = payload => {
  return RequestService.get(GET_REGIONS);
};
